import { useNavigate } from "react-router-dom";
import type { Organization } from "../../types/user";

interface OrganizationCardProps {
  organization: Organization;
  memberCount?: number;
}

const roleColors = {
  owner: "bg-blue-100 text-blue-800",
  admin: "bg-yellow-100 text-yellow-800",
  member: "bg-gray-100 text-gray-800",
};

export function OrganizationCard({ organization, memberCount }: OrganizationCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/organizations/${organization.id}`);
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
      tabIndex={0}
      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer"
    >
      <div className="flex items-start justify-between mb-2">
        <h3 className="text-lg font-semibold text-gray-900">{organization.name}</h3>
        <span
          className={`px-2 py-1 text-xs font-medium rounded-full ${roleColors[organization.role]}`}
        >
          {organization.role}
        </span>
      </div>
      <p className="text-sm text-gray-600 mb-4">/{organization.slug}</p>
      {memberCount !== undefined && (
        <p className="text-sm text-gray-500">
          {memberCount} {memberCount === 1 ? "member" : "members"}
        </p>
      )}
    </div>
  );
}
